
import { mapGetters } from 'vuex'

import ProductThumb, {
  PRODUCT_DISPLAYS,
} from '@landing/components/ProductThumb'
import { PRODUCT_SOURCE_TYPE } from '@tracking'
import { trackProductClick } from '@tracking/events'

const NUMBER_PRODUCTS_TO_DISPLAY = 2

export default {
  components: {
    ProductThumb,
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      trackingData: [],
    }
  },
  computed: {
    display() {
      return PRODUCT_DISPLAYS.CARD
    },
    LP_RESULTS: () => PRODUCT_SOURCE_TYPE.RESULTS,
    ...mapGetters({
      searchHasResults: 'landingSearch/hasResults',
    }),
    productsToDisplay() {
      return this.products.slice(0, NUMBER_PRODUCTS_TO_DISPLAY)
    },
  },
  async mounted() {
    this.trackingData = this.products.map((product, index) => {
      return {
        widgetId: null,
        list: this.LP_RESULTS,
        product: {
          brand: product.brand,
          category: product.category,
          name: product.title,
          id: product.backmarketID,
          // TODO: URL-352 Use product.id when available in Algolia to get the UUID
          uuid: product.link.params.uuid,
          price: product.price,
          currency: product.currency,
          list: this.LP_RESULTS,
          position: index + 1,
          variant: product.gradeId,
          merchantId: product.merchant_id,
          listingId: product.objectID,
        },
      }
    })
  },
  methods: {
    clickOnProductThumb(product) {
      const { backmarketID: productId } = product

      trackProductClick(
        this.trackingData.find((track) => track.product.id === productId),
      )
    },
  },
}
